import api from "../api";

export const aiService = {
  getConversationSummary: async (params = {}) => {
    const res = await api.get("/api/ai/conversation-summary/", { params });
    return res.data;
  },

  refreshConversationSummary: async (payload) => {
    const res = await api.post("/api/ai/conversation-summary/refresh/", payload);
    return res.data;
  },

  generateDraftResponse: async (payload) => {
    const res = await api.post("/api/ai/draft-response/", payload);
    return res.data;
  },

  getAiCredits: async (accountId) => {
    const res = await api.get("/api/payments/accounts/kpis/", {
      params: { account_id: accountId, code: "ai_message_credits" },
    });
    return res.data;
  },
};
